import {BaseModel} from "./Model";

export enum RegisterWay {
    MOBILE = "MOBILE",
    EMAIL = "EMAIL",
    LOGIN_NAME = "LOGIN_NAME",
    DINGTALK_AUTH = "DINGTALK_AUTH",
}

export const registerWayZh =
    {
        MOBILE: "手机号",
        EMAIL: "邮箱",
        LOGIN_NAME: "登录名",
        DINGTALK_AUTH: "钉钉授权",
    }

export default class User extends BaseModel<User> {
    name!: string
    avatar = ""
    registerWay!: RegisterWay
    loginName!: string | null
    mobile!: string | null
    email!: string | null
    deletable!: boolean
}

export class UserDetail extends User {

}
